import { marketsOptionChainTransform } from '../transforms/markets/option-chain';

export default class Options {
    constructor(option) {
        this.securityManager = option.securityManager;
        this.apiManager = option.apiManager;
    }

    async chain(params) {
        const securities = await this.securityManager.create(params.security);
        if (securities[0].isValid()) {
            const instrument = securities[0].quoteInstrument;
            const queryKey = securities[0].queryKey;
            const queryString = `${securities[0].rtMarketDataExchangeID}:${securities[0].rtSymbol}`;
            const extendParams = Object.assign({}, params, {
                query: queryString
            });
            delete extendParams.security;
            const data = await this.apiManager.getOptionChain(extendParams);
            const needSecurityFields = {
                queryKey: queryKey,
                instrument: instrument
            };
            return marketsOptionChainTransform(
                data,
                extendParams,
                needSecurityFields
            );
        } else {
            throw this.securityManager.getInvalidSecuritiesError(
                params.security
            );
        }
    }

    greeks(params) {
        return this.apiManager.getOptionGreeks(params);
    }
}
